// Vendor Libs
import { useDispatch, useSelector } from 'react-redux';
import { push as _push } from 'redux-first-history';
export var useRouter = function useRouter() {
  var dispatch = useDispatch();
  return {
    location: useSelector(function (_ref) {
      var _ref$router = _ref.router;
      _ref$router = _ref$router === void 0 ? {} : _ref$router;
      var location = _ref$router.location;
      return location;
    }),
    routerParams: useSelector(function (_ref2) {
      var _ref2$router = _ref2.router;
      _ref2$router = _ref2$router === void 0 ? {} : _ref2$router;
      var routerParams = _ref2$router.routerParams;
      return routerParams;
    }),
    push: function push() {
      return dispatch(_push.apply(void 0, arguments));
    }
  };
};